
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartOriginalScaleIec as ObiChartOriginalScaleIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-original-scale-iec.js';
 
 
 

 
 export const ObiChartOriginalScaleIec = createComponent({
   react: React,
   tagName: 'obi-chart-original-scale-iec',
   elementClass: ObiChartOriginalScaleIecElement,
   events: {
     
   }
  });
 
 